type ReferenceChecksBalance =
  | {
      expired: false;
      availableBalance: number;
      totalBalance: number;
      budgetType: 'LIMITED' | 'STANDARD';
    }
  | {
      expired: true;
      budgetType: 'LIMITED' | 'STANDARD';
    }
  | undefined;

interface JobReferenceTrackingProps {
  jobSeekReferenceStatus: 'standard' | 'limited' | null;
  orderReferenceCheckDialog:
    | 'Candidate Management - Order a Reference Check'
    | 'Candidate Management - Request a Limited Reference Check'
    | null;
  successReferenceCheckDialog:
    | 'Candidate Management - Reference Check Requested'
    | 'Candidate Management - Limited Reference Check Requested'
    | null;
  linkAction:
    | 'Order Reference Check'
    | 'Request a Limited Reference Check'
    | null;
}

export const getJobReferenceCheckTrackingProps = (
  referenceChecksBalance: ReferenceChecksBalance,
): JobReferenceTrackingProps => {
  if (referenceChecksBalance) {
    if (referenceChecksBalance.budgetType === 'STANDARD') {
      return {
        jobSeekReferenceStatus: 'standard',
        orderReferenceCheckDialog:
          'Candidate Management - Order a Reference Check',
        successReferenceCheckDialog:
          'Candidate Management - Reference Check Requested',
        linkAction: 'Order Reference Check',
      };
    }

    if (referenceChecksBalance.budgetType === 'LIMITED') {
      return {
        jobSeekReferenceStatus: 'limited',
        orderReferenceCheckDialog:
          'Candidate Management - Request a Limited Reference Check',
        successReferenceCheckDialog:
          'Candidate Management - Limited Reference Check Requested',
        linkAction: 'Request a Limited Reference Check',
      };
    }
  }

  return {
    jobSeekReferenceStatus: null,
    orderReferenceCheckDialog: null,
    successReferenceCheckDialog: null,
    linkAction: null,
  };
};

type ReferenceCheckStatus =
  | {
      status: 'available';
      referenceCheckType: 'LIMITED' | 'STANDARD';
      finishedCount: number;
      totalCount: number;
    }
  | {
      status: 'requested';
      referenceCheckType: 'LIMITED' | 'STANDARD';
    }
  | null;

export const getJobApplicationReferenceCheckTrackingProps = (
  referenceCheckStatus: ReferenceCheckStatus,
): { applicationSeekReferenceStatus: 'standard' | 'limited' | null } => {
  if (referenceCheckStatus) {
    if (referenceCheckStatus.referenceCheckType === 'STANDARD') {
      return { applicationSeekReferenceStatus: 'standard' };
    }
    if (referenceCheckStatus.referenceCheckType === 'LIMITED') {
      return { applicationSeekReferenceStatus: 'limited' };
    }
  }

  return {
    applicationSeekReferenceStatus: null,
  };
};
